export default {
  props:{
    companyId:{
      default:''
    },
    carNo:{
      default:''
    }
  },
  data(){
    return {
      data:[],
      values:[]
    }
  },
  watch:{
    values(v){
    }
  },
  created(){
    if( this.companyId ){
      this.$request.carUnbindCourier(this.companyId).then( resp => {
        if( resp.code ){
          this.$Message.error({content:rsp.msg})
        }else{
          this.data = resp.data.map( i => ({
            value:String(i.id) , label:i.groupName , 
            children: i.couriers.map(j => ({value:String(j.id) , label:j.name}))
          }))
        }
      })
    }
  },
  methods:{
    save(){
      const params = { carNo : this.carNo, courierId: this.values[this.values.length - 1]}
      if( !params.courierId ){
        this.$Modal.error({
          title: '请选择绑定的快递员',
        });
      }else{
        this.$request.carBind(params).then( resp => {
          if (!resp.code) {
            this.$Modal.success({
              title:'绑定成功',
              onOk:()=>{
                this.$emit('ok')
              }
            })
          } else {
            this.$Message.error({
              content: resp.msg
            });
          }
        })
      }
    }
  },
  render(){
    const { loading , save , data , onChange } = this
    return <div>
      <div class="modal-body">
        <Cascader data={data} filterable vModel={this.values} ></Cascader>
      </div>
      <div class="modal-footer">
        <Button loading={loading} on-click={save} type="primary">确定</Button>
      </div>
    </div>

  }
}